import { BefGlobalContext, BefPageServiceContext } from '@beflam/bef-core';
import { useRef, useContext, memo, useState } from 'react';

import BeflamChat from '../renderer/components/BeflamChat';
import FloatingAIButton from '../renderer/components/FloatingAIButton';

function Aichat(props: {}) {
  const pageService = useContext(BefPageServiceContext);
  const [pageAiVisible, setPageAiVisible] = useState(false);

  const handleInitialize = () => {
    pageService.page.doAction('pagechat', { action: 'CleanOdds' });
    setPageAiVisible(false);
  };

  const handleReset = () => {
    pageService.page.doAction('pagechat', { action: 'ResetPage' });
    setPageAiVisible(false);
  };

  return (
    <div>
      <FloatingAIButton onClick={() => setPageAiVisible(true)} />
      <div
        style={{
          display: pageAiVisible ? undefined : 'none',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          overflow: 'auto',
          zIndex: 998,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 400,
            background: 'rgba(0, 0, 0, 0.2)',
          }}
          onClick={() => setPageAiVisible(false)}
        ></div>
        <div
          style={{
            position: 'absolute',
            width: 400,
            top: 0,
            height: 40,
            right: 0,
            background: 'white',
          }}
          className="aichat-title"
        >
          <header className="app-header">
            <div className="app-title">AI</div>
            <div className="app-buttons">
              <button className="app-button" onClick={handleInitialize}>
                清除条件
              </button>
              <button className="app-button" onClick={handleReset}>
                ResetPage
              </button>
              <button
                className="app-close-button"
                onClick={() => setPageAiVisible(false)}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L11 11M1 11L11 1"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </button>
            </div>
          </header>
        </div>
        <BeflamChat
          style={{
            position: 'absolute',
            width: 400,
            top: 40,
            right: 0,
            bottom: 0,
          }}
          viewType={'page'}
          pageAiVisible={pageAiVisible}
          closePageAction={() => setPageAiVisible(false)}
        />
      </div>
    </div>
  );
}

const PageAichat = memo(Aichat);

export default PageAichat;
